import { getEnv } from "@/lib/env";
const API_BASE_URL = getEnv.VITE_API_URL || "http://localhost:3005/api/v1";

export async function makeServerApiRequest<T>(
  url: string,
  options: RequestInit = {},
): Promise<{ data: T; status: number }> {
  if (!getEnv.BACKEND_API_KEY) {
    return { data: {} as T, status: 401 };
  }
  const response = await fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      "api-key": getEnv.BACKEND_API_KEY ?? "",
      ...options.headers,
    },
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(
      `API request failed: ${response.status} ${response.statusText}`,
    );
  }

  const data = response.status !== 204 ? await response.json() : {};
  return { data, status: response.status };
}
